import { Checkbox, Form, FormInstance } from 'antd';
import CaptchaMemorial from '../../../../DLS/CaptchaMemorial';
import { useTranslation } from 'react-i18next';

const TermsOfUse = ({
  captchaToken,
  form,
  setCaptchaToken,
  setShowRequiredErrorInCaptcha,
  showCaptcha,
  showRequiredErrorInCaptcha,
}: {
  captchaToken: string;
  form: FormInstance;
  setCaptchaToken: Function;
  setShowRequiredErrorInCaptcha: Function;
  showCaptcha: boolean;
  showRequiredErrorInCaptcha: boolean;
}) => {
  const { t } = useTranslation();

  return (
    <Form form={form} scrollToFirstError className="mt-[40px]">
      <Form.Item
        required
        name="check1"
        valuePropName="checked"
        className="check-input"
        rules={[
          {
            validator: (_, value) =>
              value ? Promise.resolve() : Promise.reject(t('addCommentModal.form.check3.required')),
          },
        ]}
        label={null}
      >
        <Checkbox>
          {t('addCommentModal.form.check3.label1')}&nbsp;
          <span
            className="cursor-pointer underline"
            onClick={(e) => {
              e.preventDefault();
              window.open(`${window.location.origin}/terms?termType=privacyPolicy`, '_blank');
            }}
          >
            {t('addCommentModal.form.check3.label2')}
          </span>
        </Checkbox>
      </Form.Item>

      {showCaptcha && (
        <CaptchaMemorial
          captchaToken={captchaToken}
          showRequiredError={showRequiredErrorInCaptcha}
          setCaptchaToken={(token) => {
            showRequiredErrorInCaptcha && setShowRequiredErrorInCaptcha(false);
            setCaptchaToken(token);
          }}
        />
      )}
    </Form>
  );
};

export default TermsOfUse;
